/* eslint-disable no-unused-vars */
import React, { useState } from 'react';
import { Input, Row, Col, Divider, Select } from 'antd';
import { CloseOutlined } from '@ant-design/icons';
import { Button, Form } from '..';
import AdvanceFilterWrapper from './style';
import { RegionsHooks } from '../../hooks';

const { Option } = Select;

const Index = (props) => {
  const { onHideAdvFilter, onSearchAdvFilter, greyBg } = props;

  const [provinceCode, setProvinceCode] = useState('');
  const listOfProvinces = [];
  const listOfDistrict = [];
  // const { data: listOfProvinces } = RegionsHooks.useGetListProvinces();
  // const { data: listOfDistrict } = RegionsHooks.useGetListDistricts({
  //   provinceCode,
  // });

  const onSelectProvince = (value) => {
    const provCode = listOfProvinces.find((item) => {
      return item.name === value;
    }).code;
    setProvinceCode(provCode);
  };
  return (
    <AdvanceFilterWrapper greyBg={greyBg}>
      <Form layout="vertical" requiredMark={false} onFinish={onSearchAdvFilter}>
        <div className="containers_advanceFilter_body">
          <div className="title black1">
            <div className="font-subtitle1_medium ">Advance Filter</div>
            <CloseOutlined
              style={{ fontSize: 16 }}
              onClick={() => {
                onHideAdvFilter();
              }}
            />
          </div>
          <div className="font-paragraph_medium black1 subtitle">Location</div>
          <Row gutter={24}>
            <Col span={12}>
              <Form.Item label="Country" name="country">
                <Select>
                  <Option value="indonesia">Indonesia</Option>
                </Select>
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item label="Province" name="province">
                <Select
                  placeholder="Choose Province"
                  onSelect={(value) => {
                    onSelectProvince(value);
                  }}
                >
                  {listOfProvinces?.map((item) => {
                    return <Option value={item.name}>{item.name}</Option>;
                  })}
                </Select>
              </Form.Item>
            </Col>
          </Row>
          <Row gutter={24}>
            <Col span={12}>
              <Form.Item label="City" name="city">
                <Select>
                  {listOfDistrict?.map((item) => {
                    return (
                      <Option
                        value={item.name}
                        style={{ textTransform: 'capitalize' }}
                      >
                        {item.name}
                      </Option>
                    );
                  })}
                </Select>
              </Form.Item>
            </Col>
          </Row>
          <Divider />
          <div className="font-paragraph_medium black1 subtitle">
            Bio Detail
          </div>
          <Row gutter={24}>
            <Col span={6}>
              <Form.Item label="Gender" name="gender">
                <Select>
                  <Option value={1}>Male</Option>
                  <Option value={2}>Female</Option>
                </Select>
              </Form.Item>
            </Col>
            <Col span={6}>
              <Form.Item label="Age">
                <Input.Group>
                  <Row gutter={12}>
                    <Col span={12}>
                      <Form.Item name="min_age">
                        <Input placeholder="From" />
                      </Form.Item>
                    </Col>
                    <Col span={12}>
                      <Form.Item
                        name="max_age"
                        rules={[
                          ({ getFieldValue }) => {
                            return {
                              validator(_, value) {
                                if (
                                  !value ||
                                  Number(getFieldValue('min_age')) <
                                    Number(value)
                                ) {
                                  return Promise.resolve();
                                }
                                return Promise.reject(
                                  new Error('must greater than minimum age')
                                );
                              },
                            };
                          },
                        ]}
                      >
                        <Input placeholder="Until" />
                      </Form.Item>
                    </Col>
                  </Row>
                </Input.Group>
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item label="Education Type" name="education_type">
                <Select>
                  <Option value={1}>1</Option>
                  <Option value={2}>2</Option>
                </Select>
              </Form.Item>
            </Col>
          </Row>
          <Row gutter={24}>
            <Col span={12}>
              <Form.Item label="Relationship Status" name="relationship_status">
                <Select>
                  <Option value="true">True</Option>
                  <Option value="false">False</Option>
                </Select>
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item label="Parental Status" name="parental_status">
                <Select>
                  <Option value="true">True</Option>
                  <Option value="false">False</Option>
                </Select>
              </Form.Item>
            </Col>
          </Row>
          <Form.Item label="Income per month">
            <Input.Group>
              <Row gutter={24}>
                <Col span={12}>
                  <Form.Item name="min_income_per_month">
                    <Input placeholder="Input min amount" />
                  </Form.Item>
                </Col>
                <Col span={12}>
                  <Form.Item
                    name="max_income_per_month"
                    rules={[
                      ({ getFieldValue }) => {
                        return {
                          validator(_, value) {
                            if (
                              !value ||
                              Number(getFieldValue('min_income_per_month')) <
                                Number(value)
                            ) {
                              return Promise.resolve();
                            }
                            return Promise.reject(
                              new Error('Must greater than minimum income')
                            );
                          },
                        };
                      },
                    ]}
                  >
                    <Input placeholder="Input max amount" />
                  </Form.Item>
                </Col>
              </Row>
            </Input.Group>
          </Form.Item>
        </div>
        <div className="containers_advanceFilter_footer">
          {!greyBg && (
            <Button
              type="secondary"
              onClick={() => {
                onHideAdvFilter();
              }}
            >
              Cancel
            </Button>
          )}
          <div className="containers_advanceFilter_footer-search">
            <Button type="primary">Reset</Button>
            <Button type="primary">Search</Button>
          </div>
        </div>
      </Form>
    </AdvanceFilterWrapper>
  );
};

export default Index;
